// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F_Rf","comment":"styles_comment__3zazW"};